import { SpinLoading } from 'antd-mobile'
import React, { Suspense } from 'react'

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

export const importCompont = (importCpt) => {
  const LazyComponent = React.lazy(async () => {
    await delay(500) // 添加500ms延迟
    return importCpt()
  })
  const rt = (props) => {
    return (
      <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}><SpinLoading color='primary' /></div>}>
        <LazyComponent {...props} />
      </Suspense>
    )
  }
  return rt
}

export default importCompont
